module.exports = __webpack_public_path__ + "img/armadillomd-logo.b78e935a.png";